import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/stores/store";

const initialState = {
  acceptedId: "",
  consentedId: "",
};

const slice = createSlice({
  name: "legalConsentSlice",
  initialState,
  reducers: {
    setAcceptedId(
      state,
      {
        payload,
      }: PayloadAction<{
        acceptedId: string;
      }>
    ) {
      state.acceptedId = payload.acceptedId;
    },
    setConsentedId(
      state,
      {
        payload,
      }: PayloadAction<{
        consentedId: string;
      }>
    ) {
      state.consentedId = payload.consentedId;
    },
  },
});

export const { setAcceptedId, setConsentedId } = slice.actions;

export default slice.reducer;

export const selectAcceptedId = (state: RootState) => state.legalConsentSlice.acceptedId;

export const selectConsentedId = (state: RootState) => state.legalConsentSlice.consentedId;
